import type { Messages } from "@/i18n/locales/en";
import { legalMessagesRu } from "@/i18n/locales/legalRuData";
import { pagesMessagesRu } from "@/i18n/locales/pagesRuData";

export const ruMessages = {
  meta: {
    description:
      "WasOK — сканируйте товары, сохраняйте оценки и заметки, помните, что действительно стоило покупать.",
    title: "WasOK — Помните, что стоило покупать",
  },
  header: {
    navFeatures: "Возможности",
    navHowItWorks: "Как это работает",
    navPrivacy: "Конфиденциальность",
    navUseCases: "Сценарии",
    download: "Скачать",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    languageAria: "Язык",
  },
  hero: {
    badge: "📱 Уже доступно на Android",
    title: "Помните, что действительно стоило покупать.",
    subtitle:
      "Сканируйте товары, сохраняйте оценки и заметки и мгновенно вспоминайте, понравился ли продукт.",
    googlePlay: "Скачать в Google Play",
    watchDemo: "Смотреть демо",
    privacyLine: "Все данные остаются на вашем устройстве.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Сканируйте, чтобы помнить",
    snackCard: "Вкусно!",
    coffeeCard: "Слишком горько",
    scrollHint: "Прокрутите, чтобы узнать больше",
  },
  problems: {
    heading: "Знакомо?",
    subheading:
      "Мы все там были — стоим перед полкой и пытаемся вспомнить, понравилось ли в прошлый раз.",
    notedAgo: "✓ Вы записали это 3 месяца назад",
    items: [
      {
        question: "Какой шоколад мне реально понравился?",
        note: "Идеальная сладость",
      },
      {
        question: "Почему я перестала покупать этот шампунь?",
        note: "Сушил волосы",
      },
      {
        question: "Этот кофе был хорошим или разочаровал?",
        note: "Слишком горький",
      },
    ],
  },
  howItWorks: {
    heading: "Как это работает",
    subheading: "Четыре простых шага, чтобы не забывать своё мнение о товарах.",
    stepPrefix: "Шаг",
    steps: [
      {
        title: "Сканируйте штрихкод любого товара",
        description:
          "Быстро и просто через камеру. Работает с любым штрихкодом.",
      },
      {
        title: "Сохраняйте оценки, комментарии и фото",
        description:
          "Ставьте оценки, добавляйте заметки, фото, цены и места покупки.",
      },
      {
        title: "Мгновенно вспоминайте свой опыт",
        description:
          "При повторном сканировании увидите прошлую оценку и заметки.",
      },
      {
        title: "Создавайте умные списки покупок",
        description:
          "Формируйте списки из продуктов, которым уже доверяете.",
      },
    ],
  },
  privacy: {
    heading: "Ваша история покупок принадлежит вам.",
    body: "WasOK помогает запоминать товары, которые вы пробовали, сохраняя оценки, заметки, фото и списки покупок локально на вашем устройстве.",
    trustBanner:
      "💚 Создан вокруг вашей истории покупок — а не вокруг сбора ваших данных.",
    bullets: [
      "Аккаунт не требуется",
      "Облачная синхронизация не нужна",
      "Локальное хранение данных",
      "Резервные копии под вашим контролем",
      "Необязательный поиск информации о товаре по штрихкоду.",
      "Поддерживается рекламой Google AdMob",
    ],
  },
  features: {
    heading: "Всё необходимое",
    subheading:
      "Мощные функции, чтобы отслеживать товары было просто и приватно.",
    items: [
      {
        title: "Сканер штрихкодов",
        description: "Быстрое и точное сканирование любого товара.",
      },
      {
        title: "Оценки товаров",
        description: "Оценивайте от 1 до 5 звёзд, чтобы помнить качество.",
      },
      {
        title: "Фото товаров",
        description: "Прикрепляйте фото упаковки или деталей.",
      },
      {
        title: "Категории",
        description: "Группируйте товары по своим категориям.",
      },
      {
        title: "Где купили",
        description: "Запоминайте магазин для каждого товара.",
      },
      {
        title: "Учёт цен",
        description: "Отслеживайте цены и находите лучшие предложения.",
      },
      {
        title: "Списки покупок",
        description: "Создавайте списки из любимых продуктов.",
      },
      {
        title: "Офлайн-доступ",
        description: "Отлично работает без интернета.",
      },
      {
        title: "Локальное хранилище",
        description: "Данные надёжно хранятся на вашем устройстве.",
      },
    ],
  },
  useCases: {
    heading: "Для любого отдела",
    subheading:
      "Еда, красота или быт — WasOK помогает не забывать.",
    cards: [
      {
        emoji: "🍫",
        title: "Снеки и сладости",
        description: "Помните, какие конфеты были действительно вкусными.",
      },
      {
        emoji: "☕",
        title: "Кофе и напитки",
        description: "Отмечайте кофе, который стоит купить снова.",
      },
      {
        emoji: "💄",
        title: "Косметика и уход",
        description: "Делайте заметки о реакциях кожи.",
      },
      {
        emoji: "🧹",
        title: "Товары для дома",
        description: "Не покупайте снова то, что не оправдалось.",
      },
    ],
  },
  screenshots: {
    heading: "Красиво и понятно",
    subheading:
      "Продуманный интерфейс, которым приятно пользоваться.",
    items: [
      { title: "Сканер" },
      { title: "Карточка товара" },
      { title: "Оценка" },
      { title: "Поиск и история" },
      { title: "Список покупок" },
    ],
  },
  cta: {
    heading: "Память о покупках для реальной жизни.",
    body: "Хватит забывать, что стоило покупать. Начните умнее шоппинг уже сегодня.",
    googlePlay: "Скачать в Google Play",
    scanQr: "Сканируйте, чтобы скачать",
    tagline: "Приватно · Офлайн · Просто",
  },
  footer: {
    tagline: "Помните, что стоило покупать.",
    linksHeading: "Ссылки",
    privacyPolicy: "Политика конфиденциальности",
    terms: "Условия использования",
    contact: "Контакты",
    linkFaq: "Частые вопросы",
    linkLicenses: "Лицензии открытого ПО",
    linkAdvertising: "Реклама и монетизация",
    downloadHeading: "Скачать",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Все права защищены. Сделано с 💚 для умных покупок.",
  },
  legal: legalMessagesRu,
  faq: pagesMessagesRu.faq,
  support: pagesMessagesRu.support,
  advertising: pagesMessagesRu.advertising,
} satisfies Messages;
